<template>
  <div>
    <ul class="flex list-none flex-wrap items-center gap-4">
      <li v-for="value in filteredStorages" :key="value" class="body-2-bold">
        <span
          class="border-static-default-low text-static-default-low rounded-xs whitespace-nowrap border px-4"
        >
          {{ value }}
        </span>
      </li>
      <li
        v-if="remainingStoragesLength > 0 && filteredStorages.length > 0"
        class="text-static-default-low body-2-bold"
      >
        +{{ remainingStoragesLength }}
        <span class="sr-only">{{ i18n(translations.moreStorages) }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '~/scopes/recommendation/components/ProductCard.translations'

const MAX_TAGS = 3

const i18n = useI18n()

const props = withDefaults(
  defineProps<{
    storages: string[]
    maxTags?: number
  }>(),
  {
    maxTags: MAX_TAGS,
  },
)
const filteredStorages = computed(() => {
  return props.storages.slice(0, props.maxTags)
})
const remainingStoragesLength = computed(() => {
  return props.storages.length - filteredStorages.value.length
})
</script>
